import Vue from 'vue'
import Rest from './components/RestComponent'
import Flash from './components/FlashComponent'
import ChangeOrderLang from './components/ChangeOrderLang'
import OrganizePage from './components/OrganizePage'
import UploadThumb from './components/UploadThumb'
import UploadPictures from './components/UploadPictures'
import TextTiny from './components/TextTiny'
import OrganizePictures from './components/OrganizePictures'
import CreateCategory from './components/CreateCategory'
require('./components/updatePrices')

if (document.getElementById('rest')) {
  new Vue({
    el: 'rest',
    components: {
      Rest
    }
  })
}

if (document.getElementById('flash')) {
  new Vue({
    el: 'flash',
    components: {
      Flash
    }
  })
}


new OrganizePage(document.querySelector('#page_draggable'))
new UploadThumb(document.getElementById('thumb'), 550)
const listLang = document.querySelector('.js-list-lang')
new ChangeOrderLang(listLang)
new UploadPictures(document.getElementById('plupload'))
new OrganizePictures(document.querySelector('.list_pictures'))
new TextTiny(document.querySelector('.tinye_text'))
new CreateCategory(document.querySelector('.listPage.category'))
